/**
 * v58 interaction: cards tilt towards the cursor, main buttons follow it slightly.
 * doku/prototyp-v58/UEBERGABE.md, "Interaktion": only with a mouse, never on touch devices.
 * Values from prototype v58 index.html ("Neigung der Karten zum Cursor", "Magnetische Hauptknoepfe").
 *
 * Opt-in per element:
 *   data-ds-tilt    on a card/panel  -> rotateX/Y up to 4/5 deg, lifted 3px
 *   data-ds-magnet  on a main button -> translate up to 14%/22% of the pointer offset
 * Switched off entirely when
 *   - the device has no fine hovering pointer: (hover: hover) and (pointer: fine) is false,
 *   - the visitor asks for reduced motion: (prefers-reduced-motion: reduce),
 *   - the theme setting is off (window.themeEffects.tilt / .magnet, set in layout/theme.liquid).
 * Both media queries are watched, so switching (e.g. docking a tablet, toggling the OS setting)
 * takes effect without a reload. Works for sections loaded later (theme editor) via delegation.
 */
(function () {
  'use strict';

  var fx = window.themeEffects || {};
  var tiltOn = fx.tilt !== false;
  var magnetOn = fx.magnet !== false;
  if (!tiltOn && !magnetOn) return;
  if (!window.matchMedia) return;

  var mqPointer = window.matchMedia('(hover: hover) and (pointer: fine)');
  var mqReduce = window.matchMedia('(prefers-reduced-motion: reduce)');

  function allowed() {
    return mqPointer.matches && !mqReduce.matches;
  }

  function reset(el) {
    el.classList.remove('is-tilt-live');
    el.style.transform = '';
  }

  function resetAll() {
    document.querySelectorAll('[data-ds-tilt], [data-ds-magnet]').forEach(reset);
  }

  var current = null;

  function onMove(event) {
    if (event.pointerType && event.pointerType !== 'mouse') return;
    if (!allowed()) return;
    var target = event.target;
    if (!target || !target.closest) return;

    var magnet = magnetOn ? target.closest('[data-ds-magnet]') : null;
    var tilt = tiltOn ? target.closest('[data-ds-tilt]') : null;
    var el = magnet || tilt;

    if (current && current !== el) reset(current);
    current = el;
    if (!el) return;

    var r = el.getBoundingClientRect();
    if (!r.width || !r.height) return;

    if (el === magnet) {
      var dx = event.clientX - r.left - r.width / 2;
      var dy = event.clientY - r.top - r.height / 2;
      el.classList.add('ds-magnet');
      el.style.transform = 'translate(' + (dx * 0.14).toFixed(1) + 'px,' + (dy * 0.22).toFixed(1) + 'px)';
      return;
    }

    var x = (event.clientX - r.left) / r.width - 0.5;
    var y = (event.clientY - r.top) / r.height - 0.5;
    el.classList.add('ds-tilt', 'is-tilt-live');
    el.style.transform =
      'perspective(900px) rotateX(' + (-y * 4).toFixed(2) + 'deg) rotateY(' + (x * 5).toFixed(2) + 'deg) translateY(-3px)';
  }

  function onLeave(event) {
    if (!current) return;
    var to = event.relatedTarget;
    if (to && current.contains(to)) return;
    if (!current.contains(event.target)) return;
    reset(current);
    current = null;
  }

  document.addEventListener('pointermove', onMove, { passive: true });
  document.addEventListener('pointerout', onLeave, { passive: true });
  window.addEventListener('blur', function () {
    if (current) reset(current);
    current = null;
  });

  function onMediaChange() {
    if (!allowed()) {
      resetAll();
      current = null;
    }
  }
  if (mqPointer.addEventListener) {
    mqPointer.addEventListener('change', onMediaChange);
    mqReduce.addEventListener('change', onMediaChange);
  }
})();
